import { ZMfNodeGroup } from "../../ZMfNode";

export const groupBlockId = (meta: ZMfNodeGroup): string =>
  `_group_${meta.name}`;
